import React from "react";
import PropTypes from "prop-types";

import { filters } from "MODULES/Notifications/components/Search/Search";
import { FilterSelect } from "MODULES/shared/components";

const FilterDropdown = ({ setFilters, title }) => (
  <FilterSelect filters={filters} setFilters={setFilters} title={title} />
);

FilterDropdown.propTypes = {
  setFilters: PropTypes.func.isRequired,
  title: PropTypes.string
};

export default FilterDropdown;



// WEBPACK FOOTER //
// ./app/Nav/Notifications/FilterDropdown.jsx